import FileMixin from '~/mixins/FileMixin'

export default {
  name: 'FileItem',
  mixins: [FileMixin],
  props: {
    title: { type: String, required: true },
    link: { type: String, required: true },
  },
}
